import React from "react"
import AnciennesMesures from "./mesure_components/AnciennesMesures"
import Formulaire from "./mesure_components/Formulaire"
import ActiveTabs from "./mesure_components/ActiveTabs"
import {observer} from "mobx-react"
import MesureStore from './MesureStore'
import {ActNature, MesureScope, TypesMesures} from "../../Shared/Enums/Enums";
import Helper from "../../Shared/Helper";
import {missingMesures} from "../AppointmentValidation";
import {t} from "../../I18n/i18n"
import WebToDesktop from "../../WebToDesktop/WebToDesktop";
import ImportMeasureDropZone from "./mesure_components/Import/ImportMeasureDropZone";

@observer
class Mesure extends React.Component {
    constructor(props) {
        super(props);
        this.choixMesure = this.choixMesure.bind(this)
        this.choixMesureByTabs = this.choixMesureByTabs.bind(this)
        this.importMesure = this.importMesure.bind(this)
        this.deleteMesure = this.deleteMesure.bind(this)
        this.spreadMesure = this.spreadMesure.bind(this)
        this.state = {
            typedemesure: "",
            mesureName: ""
        };
    }


    componentDidMount() {
    }

    choixMesure(e) {
        // No need to save an empty measure
        // if (this.state.typedemesure != "") { //enregistrement
        //     MesureStore.saveMesure()
        // }

        let m = "";
        MesureStore.typesdemesures.map((mesure, index) => {
            if (mesure.id == e.target.value) {
                m = mesure.titre
            }
        })

        this.setState({
            typedemesure: e.target.value,
            mesureName: m
        })
        MesureStore.updateForm(e.target.value)
        MesureStore.typedemesure = parseInt(e.target.value)
        MesureStore.loadKindsMesures()

    }

    choixMesureByTabs(mesure) {
        // if (this.state.typedemesure != "") { //enregistrement
        //     MesureStore.saveMesure()
        // }
        this.setState({
            typedemesure: mesure.id,
            mesureName: mesure.titre
        })
        MesureStore.updateForm(mesure.id)
        MesureStore.typedemesure = mesure.id
        MesureStore.loadKindsMesures()

    }

    deleteMesure(mesureType) {
        if (mesureType) {
            MesureStore.deleteMesure(mesureType.mesure_id)

            this.setState({
                typedemesure: mesureType.id != this.state.typedemesure ? this.state.typedemesure : ""
            })
        }
    }

    spreadMesure(mesure) {
        if (["20", 18, 19, "21"].includes(this.state.typedemesure)) {
            return
        }
        const od_sphere = mesure.od_sphere === "plan" ? 0 : parseFloat(mesure.od_sphere)
        if (od_sphere) MesureStore.set_od_sphere(od_sphere)
        if (!isNaN(parseFloat(mesure.od_cylindre))) MesureStore.set_od_cylindre(parseFloat(mesure.od_cylindre))
        if (!isNaN(parseInt(mesure.od_axe))) MesureStore.set_od_axe(parseInt(mesure.od_axe))
        if (!["11"].includes(this.state.typedemesure)) {
            if (!isNaN(parseFloat(mesure.od_addition))) MesureStore.set_od_addition(parseFloat(mesure.od_addition))
            if (!isNaN(parseFloat(mesure.og_addition))) MesureStore.set_og_addition(parseFloat(mesure.og_addition))
        }
        if (!["7", "11"].includes(this.state.typedemesure)) {
            if (!isNaN(parseFloat(mesure.od_parinaud))) MesureStore.set_od_parinaud(parseFloat(mesure.od_parinaud))
            if (!isNaN(parseFloat(mesure.og_parinaud))) MesureStore.set_og_parinaud(parseFloat(mesure.og_parinaud))
        }
        const og_sphere = mesure.og_sphere === "plan" ? 0 : parseFloat(mesure.og_sphere)
        if (og_sphere) MesureStore.set_og_sphere(og_sphere)
        if (!isNaN(parseFloat(mesure.og_cylindre))) MesureStore.set_og_cylindre(parseFloat(mesure.og_cylindre))
        if (!isNaN(parseInt(mesure.og_axe))) MesureStore.set_og_axe(parseInt(mesure.og_axe))
    }

    importMesure(id) {
        this.setState({typedemesure: id})
        MesureStore.loadKindsMesures()
    }

    renderBody = () => {
        const mesures = MesureStore.typesdemesures
            .slice()
            .filter(m => (m.scope === MesureScope.GLOBAL) || (m.scope === MesureScope.MEDICAL_EVENT && MesureStore.selected_act.nature === ActNature.NURSE.name))
            .sort((a, b) => {
                return Object.values(TypesMesures).indexOf(a.titre) > Object.values(TypesMesures).indexOf(b.titre) ? 1 : -1;
            });

        return <div style={{margin: 20, overflowY: "scroll"}}>
            <div className="row">
                <div className="col s12 m3">
                    <div className="bordered"></div>
                    <ActiveTabs clickFunc={this.choixMesureByTabs} delete={this.deleteMesure}
                                type={this.state.typedemesure} spread={this.spreadMesure}/>
                    <select
                        onChange={this.choixMesure}
                        value={this.state.typedemesure}
                        className="browser-default"
                        data-cy="MesureSelection">
                        <option value="" data-cy="MesureOption">{t("ACTIVE_TABS.OPTION_MEASURE")}</option>
                        {mesures.map((mesure, index) => {
                            let prefix = ""
                            if (missingMesures().flat().includes(mesure.titre)) {
                                const isFirstElement = missingMesures().reduce((acc, arr) => acc.concat(arr[0]), []).includes(mesure?.titre)
                                prefix = isFirstElement ? "OBLIGATOIRE : " : "OU : "
                            }
                            if ([TypesMesures.KERATOMETRY, TypesMesures.NO_CORRECTION, TypesMesures.AUTOREF_SKIACOL, TypesMesures.FINALE_REF].includes(mesure?.titre)) {
                                return [
                                    <option
                                        data-cy="MesureOption"
                                        key={index}
                                        value={mesure.id}>
                                        {prefix}{mesure.titre}</option>,
                                    <option key={"mesure-" + index} data-cy="MesureOption" value={undefined}
                                            disabled>————————————————————————</option>,
                                ]
                            }
                            return <option data-cy="MesureOption" key={"mesure-option" + index}
                                           value={mesure.id}>{prefix}{mesure.titre}
                            </option>
                        })}
                    </select>
                </div>
                <div className="col s12 m9" style={{padding: "40px"}}>
                    {this.state.typedemesure === "" ? (
                        <p className="center" data-cy="NoMesureTypeSelected">{t("ACTIVE_TABS.NO_TYPE_SELECTED")}</p>
                    ) : (
                        <React.Fragment>
                            <p className="center">{MesureStore.AvMesuresAnalisis}</p>
                            <Formulaire mesureName={Helper.capitalizeFirstLetter(this.state.mesureName)}/>
                        </React.Fragment>
                    )}
                </div>
                {/*<div className="col s12 m2">*/}
                {/*    <div style={{display: "flex", flexDirection: "column"}}>*/}
                {/*        <AnciennesMesures importMesure={this.importMesure}/>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
        </div>
    }

    render() {
        return <div>
            <div style={{position: "fixed", bottom: 100, left: 5, zIndex: 2}}>
                <ImportMeasureDropZone/>
            </div>
            <div style={{zIndex: 1}}>
                {this.renderBody()}
            </div>
        </div>
    }
}

export default Mesure
